// src/services/documentTemplate.service.js
import { api } from './api';

class DocumentTemplateService {
    /**
     * Get all document templates
     */
    async getTemplates() {
        try {
            const response = await api.get('/api/functional-structure/templates');
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching templates:', error);
            return this.getLocalStorageTemplates();
        }
    }

    /**
     * Get selected templates only
     */
    async getSelectedTemplates() {
        try {
            const response = await api.get('/api/admin/document-templates/selections');
            return response.data.selections || {};
        } catch (error) {
            console.error('Error fetching selected templates:', error);
            return this.getLocalStorageTemplates();
        }
    }

    /**
     * Create new template
     */
    async createTemplate(templateData) {
        try {
            const response = await api.post('/api/functional-structure/templates', templateData);
            return response.data.data;
        } catch (error) {
            console.error('Error creating template:', error);
            throw error;
        }
    }

    /**
     * Update template
     */
    async updateTemplate(id, templateData) {
        try {
            const response = await api.put(`/api/functional-structure/templates/${id}`, templateData);
            return response.data.data;
        } catch (error) {
            console.error('Error updating template:', error);
            throw error;
        }
    }

    /**
     * Delete template
     */
    async deleteTemplate(id) {
        try {
            const response = await api.delete(`/api/functional-structure/templates/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting template:', error);
            throw error;
        }
    }

    /**
     * Update selected templates (for each category)
     */
    async updateSelectedTemplates(selectedTemplates) {
        try {
            // Save to backend
            const response = await api.post('/api/admin/document-templates/selections', {
                selections: selectedTemplates
            });

            // Also save to localStorage for offline access
            this.saveToLocalStorage(selectedTemplates);

            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error updating selected templates:', error);
            // Fallback to localStorage
            this.saveToLocalStorage(selectedTemplates);
            return { success: false, error: error.message };
        }
    }

    /**
     * Fallback: Get templates from localStorage
     */
    getLocalStorageTemplates() {
        try {
            const stored = localStorage.getItem('selectedDocumentTemplates');
            return stored ? JSON.parse(stored) : {};
        } catch (error) {
            console.error('Error loading templates from localStorage:', error);
            return {};
        }
    }

    /**
     * Save to localStorage for offline access
     */
    saveToLocalStorage(templates) {
        try {
            localStorage.setItem('selectedDocumentTemplates', JSON.stringify(templates));
        } catch (error) {
            console.error('Error saving templates to localStorage:', error);
        }
    }
}

export default new DocumentTemplateService();
